import { Link } from "react-router-dom";
import { Award, Target, HeartHandshake, CheckCircle2 } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { COACH_HEADSHOT } from "../lib/brand";

const COACH = COACH_HEADSHOT;
const CERTS = ["Certified Personal Trainer (CPT)", "Precision Nutrition L1", "Strength & Conditioning Specialist", "HYROX Coach", "Pre/Post-Natal Fitness"];

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHeader overline="Our Story" title={<>Coaching that<br />respects your life</>}
        subtitle="BeingFitForYou was built on one belief: fitness should be sustainable, science-based and honest — for every body and every goal." />
      <section className="mx-auto max-w-[1400px] px-5 lg:px-8 py-16 md:py-24">
        <Reveal>
          <div className="max-w-md mx-auto rounded-lg overflow-hidden border border-border mb-14"><img src={COACH} alt="Coach Abhishek" className="w-full h-auto" /></div>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="max-w-3xl mx-auto text-center">
            <p className="text-xs uppercase tracking-[0.25em] text-primary font-bold mb-4">Meet the Coach</p>
            <h2 className="font-display font-800 uppercase text-4xl md:text-5xl tracking-tight">Coach Abhishek</h2>
            <p className="text-muted-foreground mt-5 leading-relaxed">With over 8 years of coaching experience, I've helped 500+ people lose fat, build strength and — most importantly — keep it for life. No crash diets, no gimmicks. Just sustainable, science-backed training and nutrition tailored to you.</p>
            <p className="text-muted-foreground mt-4 leading-relaxed">Whether you're a busy professional, a complete beginner, or prepping for HYROX, my job is to make fitness fit your life — not the other way around.</p>
            <div className="mt-7 grid sm:grid-cols-2 gap-2.5 text-left max-w-xl mx-auto">
              {CERTS.map((c) => (<div key={c} className="flex items-center gap-3 text-sm"><CheckCircle2 size={17} className="text-primary shrink-0" /> {c}</div>))}
            </div>
          </div>
        </Reveal>
      </section>
      <section className="bg-card border-y border-border">
        <div className="mx-auto max-w-[1400px] px-5 lg:px-8 py-16 md:py-24 grid gap-6 md:grid-cols-3">
          {[{ icon: Target, t: "Mission", d: "Make sustainable fitness accessible to every body, at every stage of life." },
            { icon: Award, t: "Vision", d: "Become India's most trusted, honest coaching brand — zero gimmicks." },
            { icon: HeartHandshake, t: "Philosophy", d: "Habits over hacks. Consistency over intensity. Progress over perfection." }].map((x, i) => (
            <Reveal key={x.t} delay={i * 0.08}>
              <div className="border border-border rounded-lg p-8 bg-background h-full">
                <div className="grid place-items-center w-12 h-12 rounded-full bg-primary/10 text-primary mb-5"><x.icon size={22} /></div>
                <h3 className="font-display font-700 uppercase text-2xl tracking-tight">{x.t}</h3>
                <p className="text-muted-foreground text-sm mt-2">{x.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <section className="mx-auto max-w-[1400px] px-5 lg:px-8 py-20 text-center">
        <h2 className="font-display font-900 uppercase text-4xl md:text-5xl tracking-tight">Let's build your best self.</h2>
        <Link to="/assessment" className="inline-block mt-7 bg-primary text-primary-foreground px-8 py-4 rounded-full text-xs uppercase tracking-[0.15em] font-bold hover:scale-[1.03] transition-transform">Start Free Assessment</Link>
      </section>
    </div>
  );
}
